import React from "react";
import {  Outlet } from "react-router-dom";
import { useAuth } from "../AuthProvider";

const PrivateRoute = () => {
  const authContext = useAuth();
  console.log(authContext.token);
  if (authContext.token) 
    return <Outlet />;
};

export default PrivateRoute;